
interface ComboGalleryProps {
  lang: 'en' | 'ja';
}

export default function ComboGallery({ lang }: ComboGalleryProps) {
  const t = {
    en: { badge: 'Gallery', title: 'A Night to Remember' },
    ja: { badge: 'ギャラリー', title: '忘れられない一夜' },
  }[lang];

  const images = [
    {
      src: 'https://public.readdy.ai/ai/img_res/a885befe11f52af7120e54785aa2166f.jpg',
      alt: 'Local Izakaya Experience',
      span: 'col-span-2 row-span-2',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=japanese%20karaoke%20box%20private%20room%20neon%20pink%20purple%20lights%20microphone%20big%20screen%20song%20list%20modern%20interior%20fun%20atmosphere%20friends%20singing%20together%20tokyo%20entertainment%20night&width=600&height=400&seq=combo-gallery-karaoke-001&orientation=landscape',
      alt: 'Karaoke Box',
      span: 'col-span-1 row-span-1',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=cold%20japanese%20beer%20glass%20frosty%20mug%20izakaya%20table%20with%20edamame%20yakitori%20small%20plates%20wooden%20table%20warm%20light%20bokeh%20background%20authentic%20japanese%20pub%20food%20drinks&width=600&height=400&seq=combo-gallery-drinks-001&orientation=landscape',
      alt: 'Drinks & Food',
      span: 'col-span-1 row-span-1',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=tokyo%20night%20street%20neon%20signs%20glowing%20entertainment%20district%20people%20walking%20izakaya%20karaoke%20signs%20amber%20pink%20lights%20reflections%20wet%20pavement%20lively%20urban%20nightlife%20atmosphere%20cinematic&width=600&height=400&seq=combo-gallery-street-001&orientation=landscape',
      alt: 'Tokyo Night Street',
      span: 'col-span-1 row-span-1',
    },
    {
      src: 'https://readdy.ai/api/search-image?query=karaoke%20microphone%20close%20up%20neon%20lights%20colorful%20bokeh%20background%20japanese%20karaoke%20room%20fun%20party%20atmosphere%20tambourine%20on%20table%20song%20book%20screen%20glow&width=600&height=400&seq=combo-gallery-mic-001&orientation=landscape',
      alt: 'Karaoke Microphone',
      span: 'col-span-1 row-span-1',
    },
  ];

  return (
    <section className="py-20 px-4 bg-gray-900 text-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/5 border border-white/10 rounded-full mb-5">
            <i className="ri-image-line text-pink-400 text-sm"></i>
            <span className="text-gray-300 text-sm">{t.badge}</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white">{t.title}</h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 auto-rows-[200px]">
          {images.map((img, i) => (
            <div
              key={i}
              className={`${img.span} rounded-xl overflow-hidden relative group cursor-pointer`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-end p-4">
                <span className="text-white text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {img.alt}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
